/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Cargo_Apply_Diff_To_Related_SelectedInputs */

const en_cargo_apply_diff_to_related_selected = /** @type {(inputs: Cargo_Apply_Diff_To_Related_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Applying diff to all ${i?.count} related cargos`)
};

const es_cargo_apply_diff_to_related_selected = /** @type {(inputs: Cargo_Apply_Diff_To_Related_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aplicando dif a las ${i?.count} cargas relacionadas`)
};

/**
* | output |
* | --- |
* | "Applying diff to all {count} related cargos" |
*
* @param {Cargo_Apply_Diff_To_Related_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_apply_diff_to_related_selected = /** @type {((inputs: Cargo_Apply_Diff_To_Related_SelectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Apply_Diff_To_Related_SelectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_apply_diff_to_related_selected(inputs)
	return es_cargo_apply_diff_to_related_selected(inputs)
});